export default {
  socketHost: 'wss://td-server.blahy.ovh',
  debug: false,
}